// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/github-markdown-css/5.8.1/github-markdown.min.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --page-bg: #050715;
  --hero-bg: linear-gradient(135deg, #050915, #0c1448);
  color-scheme: dark;
  font-family: "Inter", sans-serif;
  background-color: var(--page-bg);
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  min-height: 100vh;
  background: var(--hero-bg);
  color: #e5e7ff;
}

#app {
  min-height: 100vh;
  padding: 2rem clamp(1rem, 2vw, 3rem);
  display: flex;
  flex-direction: column;
}

.toolbar {
  width: min(980px, 100%);
  margin: 0 auto 0;
  display: flex;
  justify-content: flex-end;
}

#export-pdf-btn {
  border: 1px solid var(--borderColor-default, rgba(255, 255, 255, 0.2));
  background: var(--bgColor-default, #0d1117);
  color: var(--fgColor-default, #e6edf3);
  border-radius: 10px;
  padding: 0.55rem 0.9rem;
  font: inherit;
  cursor: pointer;
}

#export-pdf-btn:hover {
  background: var(--bgColor-muted, #161b22);
}

.markdown-shell {
  overflow-x: auto;
  padding: 1.5rem;
  border-radius: 32px;
}

.markdown-body {
  box-sizing: border-box;
  min-width: 200px;
  max-width: 980px;
  margin: 0 auto;
  padding: 2rem;
}


@media print {
  body {
    background: #fff;
    color: #000;
  }

  #app {
    padding: 0;
  }

  .toolbar {
    display: none;
  }

  .markdown-shell {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  .markdown-body {
    max-width: 100%;
    margin: 0;
    padding: 0;
    color: #000;
    background: #fff;
  }
}

@media (max-width: 768px) {

  .markdown-body {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAGA;EACE,kBAAkB;EAClB,oDAAoD;EACpD,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sEAAsE;EACtE,2CAA2C;EAC3C,sCAAsC;EACtC,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;;AAGA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;;EAEE;IACE,aAAa;EACf;AACF","sourcesContent":["@import url('https://cdnjs.cloudflare.com/ajax/libs/github-markdown-css/5.8.1/github-markdown.min.css');\n@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\n\n:root {\n  --page-bg: #050715;\n  --hero-bg: linear-gradient(135deg, #050915, #0c1448);\n  color-scheme: dark;\n  font-family: \"Inter\", sans-serif;\n  background-color: var(--page-bg);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  min-height: 100vh;\n  background: var(--hero-bg);\n  color: #e5e7ff;\n}\n\n#app {\n  min-height: 100vh;\n  padding: 2rem clamp(1rem, 2vw, 3rem);\n  display: flex;\n  flex-direction: column;\n}\n\n.toolbar {\n  width: min(980px, 100%);\n  margin: 0 auto 0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n#export-pdf-btn {\n  border: 1px solid var(--borderColor-default, rgba(255, 255, 255, 0.2));\n  background: var(--bgColor-default, #0d1117);\n  color: var(--fgColor-default, #e6edf3);\n  border-radius: 10px;\n  padding: 0.55rem 0.9rem;\n  font: inherit;\n  cursor: pointer;\n}\n\n#export-pdf-btn:hover {\n  background: var(--bgColor-muted, #161b22);\n}\n\n.markdown-shell {\n  overflow-x: auto;\n  padding: 1.5rem;\n  border-radius: 32px;\n}\n\n.markdown-body {\n  box-sizing: border-box;\n  min-width: 200px;\n  max-width: 980px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n\n@media print {\n  body {\n    background: #fff;\n    color: #000;\n  }\n\n  #app {\n    padding: 0;\n  }\n\n  .toolbar {\n    display: none;\n  }\n\n  .markdown-shell {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n  }\n\n  .markdown-body {\n    max-width: 100%;\n    margin: 0;\n    padding: 0;\n    color: #000;\n    background: #fff;\n  }\n}\n\n@media (max-width: 768px) {\n\n  .markdown-body {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
